// extracted by mini-css-extract-plugin
export default {"page":"PP","wrapper":"QP","text":"RP","icons":"SP","icon":"TP","icon_text":"UP","carousel_wrapper":"VP","slide":"WP","image":"XP","arrows":"YP","prev":"ZP","modal_root":"aQ","x_mark":"bQ","modal":"cQ","images":"eQ","main_image":"fQ","name":"gQ"};
    if(module.hot) {
      // 1738836197361
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  